// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Egk9N2u"};